import Component from './GeoMonitor.vue';

export default {
  install(Vue) {
    Vue.component('BkfGeoMonitor', Component);
  },
};
